import { render, staticRenderFns } from "./TableColumnActions.vue?vue&type=template&id=b6b01f32&scoped=true&"
import script from "./TableColumnActions.vue?vue&type=script&lang=js&"
export * from "./TableColumnActions.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnActions.vue?vue&type=style&index=0&id=b6b01f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b01f32",
  null
  
)

export default component.exports